export default "__VITE_ASSET__zbBjy4hQ__"